// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import {
  AnalyticsCallOptions,
  getAnalytics,
  logEvent,
  setUserId,
} from 'firebase/analytics';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyCF_W4H2PfFfpjPD2XrNqUXM3tuxvxhTqY',
  authDomain: 'advanta-93bd5.firebaseapp.com',
  projectId: 'advanta-93bd5',
  storageBucket: 'advanta-93bd5.appspot.com',
  messagingSenderId: '210807662998',
  appId: '1:210807662998:web:84f9e4912a8599ca4d15b7',
  measurementId: 'G-X2GKB611H3',
};

const isTestingOnLocal = false;
// Initialize Firebase
const isProd =
  isTestingOnLocal ||
  window.location.origin == 'https://advanta.nurture.farm';
const app = isProd
  ? initializeApp(firebaseConfig)
  : undefined;
export const appGetAnalytics = isProd
  ? () => getAnalytics(app)
  : () => {};
const analytics = isProd ? appGetAnalytics() : null;

export const appLogEvent = (
  eventName: string,
  eventParams?:
    | {
        [key: string]: unknown;
      }
    | undefined,
  options?: AnalyticsCallOptions | undefined
) => {
  if (isProd && analytics) {
    logEvent(analytics, eventName, eventParams, options);
  }
};

export { CUSTOM_EVENTS } from './customEvents';

export const setGAUserId = (userId: string | undefined) => {
  if (isProd && analytics && userId) {
    setUserId(analytics, userId);
  }
};
